import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/popup.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-e2e5e050")

_pushScopeId("data-v-e2e5e050")
const _hoisted_1 = { class: "card content-card" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Povijest ažuriranja ")
const _hoisted_3 = {
  id: "app-types",
  class: "card"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Verzija 5.2"),
  /*#__PURE__*/_createVNode("span", null, "(15.11.2024.)")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, "Dodane preporuke/oglašavanje sadržaja."),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createTextVNode("e-Dnevnik Plus "),
    /*#__PURE__*/_createVNode("span", { class: "plus" }, "Classic"),
    /*#__PURE__*/_createTextVNode(":")
  ]),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, "Unaprijeđeno sučelje i upute na popisu predmeta.")
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createTextVNode("e-Dnevnik Plus "),
    /*#__PURE__*/_createVNode("span", { class: "plus" }, "App"),
    /*#__PURE__*/_createTextVNode(":")
  ]),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, "Ažurirani bodovi u kalkulatoru za upis u srednje škole.")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Verzija 5.1"),
  /*#__PURE__*/_createVNode("span", null, "(7.1.2024.)")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, " Proširenje je prilagođeno novoj verziji e-Dnevnika. Nakon 5 godina, vraćeni su prosjeci. "),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createTextVNode("e-Dnevnik Plus "),
    /*#__PURE__*/_createVNode("span", { class: "plus" }, "Classic"),
    /*#__PURE__*/_createTextVNode(":")
  ]),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, "Nakon instalacije, ovo je zadana verzija proširenja."),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Na stranici odabira predmeta, prosjek svakog predmeta moguće je mijenjati. "),
      /*#__PURE__*/_createVNode("ul", null, [
        /*#__PURE__*/_createVNode("li", null, " Skrolanjem iznad predmetnog prosjeka povećava se ili smanjuje vrijednost. "),
        /*#__PURE__*/_createVNode("li", null, "Desnim klikom na predmetni prosjek poništava se izmjena."),
        /*#__PURE__*/_createVNode("li", null, "Klikom na završni prosjek poništavaju se sve izmjene.")
      ])
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Na stranici predmeta moguće je ručno unositi ocjene. "),
      /*#__PURE__*/_createVNode("ul", null, [
        /*#__PURE__*/_createVNode("li", null, "Klikom na prosjek poništavaju se sve izmjene.")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createTextVNode("e-Dnevnik Plus "),
    /*#__PURE__*/_createVNode("span", { class: "plus" }, "App"),
    /*#__PURE__*/_createTextVNode(":")
  ]),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, "Riješeni problemi kompatibilnosti s novim e-Dnevnikom."),
    /*#__PURE__*/_createVNode("li", null, "Ažurirani bodovi u kalkulatoru za upis u srednje škole.")
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "(2.3.2023.)", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createTextVNode("e-Dnevnik Plus "),
    /*#__PURE__*/_createVNode("span", { class: "plus" }, "App"),
    /*#__PURE__*/_createTextVNode(":")
  ]),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, "Dodana opcija \"Ispis potvrda\" klikom na korisnika."),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Ažuriran kalkulator za upis u srednje škole. "),
      /*#__PURE__*/_createVNode("ul", null, [
        /*#__PURE__*/_createVNode("li", null, "Ažurirani dodatni bodovi."),
        /*#__PURE__*/_createVNode("li", null, "Ažurirani bodovi potrebni za upis.")
      ])
    ])
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Verzija 5.0.1"),
  /*#__PURE__*/_createVNode("span", null, "(22.11.2021.)")
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createTextVNode("e-Dnevnik Plus "),
    /*#__PURE__*/_createVNode("span", { class: "plus" }, "App"),
    /*#__PURE__*/_createTextVNode(":")
  ]),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Opcija \"Prikaži boje ocjena\" podjeljena je na dvije nove opcije: "),
      /*#__PURE__*/_createVNode("ul", null, [
        /*#__PURE__*/_createVNode("li", null, "Prikaži boje ocjena po ukupnom broju"),
        /*#__PURE__*/_createVNode("li", null, "Prikaži boje ocjena po mjesecima")
      ])
    ]),
    /*#__PURE__*/_createVNode("li", null, "Smanjen zum cijele aplikacije za 10%."),
    /*#__PURE__*/_createVNode("li", null, "Dodana opcija prikaza lozinke kod prijave.")
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createTextVNode("e-Dnevnik Plus "),
    /*#__PURE__*/_createVNode("span", { class: "plus" }, "Classic"),
    /*#__PURE__*/_createTextVNode(":")
  ]),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, " Dodana opcija automatske prijave (kvačica na /login stranici). ")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Verzija 5.0"),
  /*#__PURE__*/_createVNode("span", null, "(11.11.2021.)")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, "Uklonjene sve funkcionalnosti prethodne verzije proširenja."),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" Novi prozor proširenja omogućuje odabir verzije e-Dnevnika: "),
    /*#__PURE__*/_createVNode("span", { class: "plus" }, "App"),
    /*#__PURE__*/_createTextVNode(" ili "),
    /*#__PURE__*/_createVNode("span", { class: "plus" }, "Classic"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" Odabrana verzija postaje zadana te se svaki put otvara navigacijom na "),
    /*#__PURE__*/_createVNode("a", {
      href: "ocjene.skole.hr",
      class: "plus"
    }, "ocjene.skole.hr"),
    /*#__PURE__*/_createVNode("img", {
      class: "card",
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("span", { class: "plus" }, "App"),
    /*#__PURE__*/_createTextVNode(" verzija je nova aplikacija za napredan pregled sadržaja s e-Dnevnika: "),
    /*#__PURE__*/_createVNode("ul", null, [
      /*#__PURE__*/_createVNode("li", null, " Osnovne lokacije su: Razred, Kalendar, Statistika ocjena i Kalkulator bodova. "),
      /*#__PURE__*/_createVNode("li", null, " Sve promjene ostaju automatski spremljene za prijavljenog korisnika. ")
    ])
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("span", { class: "plus" }, "Classic"),
    /*#__PURE__*/_createTextVNode(" verzija dodaje prosjeke na stranici e-Dnevnika: "),
    /*#__PURE__*/_createVNode("ul", null, [
      /*#__PURE__*/_createVNode("li", null, " Na stranici odabira predmeta, za svaki predmet i završni prosjek. "),
      /*#__PURE__*/_createVNode("li", null, "Na stranici predmeta.")
    ])
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Verzija <= 4.8"),
  /*#__PURE__*/_createVNode("span", null, "(21.3.2019.)")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("a", {
  class: "plus",
  href: "https://chrisross5.github.io/e-dnevnik-plus-homepage-old/"
}, "https://chrisross5.github.io/e-dnevnik-plus-homepage-old/", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Nema novosti.")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h2", null, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: { 'selected-app': !_ctx.selectedApp },
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedApp = 0))
        }, " za učenike i roditelje ", 2),
        _createVNode("div", {
          class: { 'selected-app': _ctx.selectedApp },
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedApp = 1))
        }, " za nastavnike ", 2)
      ])
    ]),
    (!_ctx.selectedApp)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createVNode("h3", null, [
            _createTextVNode("Verzija " + _toDisplayString(_ctx.$lastVersion), 1),
            _hoisted_8
          ]),
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _hoisted_15
        ], 64))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _hoisted_16
        ], 64))
  ]))
})